import { Component, inject, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TranslocoPipe } from '@ngneat/transloco';
import { MatStepperNext } from '@angular/material/stepper';
import { Room, RoomProtocol } from '@shared/transport.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs';
import { QrCodeComponent } from '@shared/component/ui/qr-code/qr-code.component';
import { RoomService } from '@shared/service/room.service';
import { IonicModule } from '@ionic/angular';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';

@UntilDestroy()
@Component({
  selector: 'app-share-protocol',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    QrCodeComponent,
    TranslocoPipe,
    MatStepperNext,
    IonicModule
  ],
  templateUrl: './share-protocol.component.html',
  styleUrl: './share-protocol.component.scss'
})
export class ShareProtocolComponent implements OnInit {
  @Input() closeModal: (result?: any) => void;
  @Input() data: any;

  protected protocol: RoomProtocol;
  protected room: Room;
  protected pending = false;

  private _roomService = inject(RoomService);

  constructor() {
    addIcons({ closeOutline });
  }

  ngOnInit(): void {
    if (this.data) {
      this.protocol = this.data.protocol;
      this.room = this.protocol.room;
    }
  }

  shareProtocol(): void {
    this.pending = true;
    this._roomService.shareProtocol(this.room.roomId, this.protocol.id)
      .pipe(untilDestroyed(this), finalize(() => this.pending = false))
      .subscribe(res => {
        this.closeModal(res);
      });
  }
}
